module.exports = __webpack_public_path__ + "static/color element-06-385e0e88b80bdc9cf5b320575a2f6e19.png";